import React from 'react';

import { RouteContext } from 'src/context';
import { useDrawerWidth } from 'src/features/drawer/useDrawerWidth';
import { PageContent, ShowSidebarConfig } from 'src/legacy/components/UI';
import { useRouteAccess } from 'src/routes/routeAccess';

export interface PageLayoutProps {
  routeAccessCheck?: keyof ReturnType<typeof useRouteAccess>['routeAccess'];
  showSidebar?: ShowSidebarConfig;
  showToolbar?: boolean;
  fullpage?: boolean;
  showSpace?: boolean;
  unauthAccessAllowed?:
    | boolean
    | keyof ReturnType<typeof useRouteAccess>['routeAccess'];
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  routeAccessCheck,
  children,
  showSidebar = ShowSidebarConfig.Show,
  showToolbar = true,
  fullpage = false,
  showSpace = true,
  unauthAccessAllowed = false,
}) => {
  const { routeAccess, isLoading } = useRouteAccess();
  const drawerWidth = useDrawerWidth();
  const { pathname } = React.useContext(RouteContext);
  const isSettingsPage = pathname.startsWith('/settings');
  const allowed = routeAccessCheck ? routeAccess[routeAccessCheck] : undefined;
  const unauthAccessAllowedBool =
    typeof unauthAccessAllowed === 'string'
      ? routeAccess[unauthAccessAllowed]
      : unauthAccessAllowed;

  return (
    <PageContent
      drawerWidth={drawerWidth}
      isAccessLoading={isLoading}
      allowed={allowed}
      showToolbar={showToolbar}
      showSidebar={showSidebar}
      fullPage={fullpage}
      showSpace={showSpace}
      isSettingsPage={isSettingsPage}
      unauthAccessAllowed={unauthAccessAllowedBool}
    >
      {children}
    </PageContent>
  );
};
